var render, staticRenderFns
import script from "./SoilChart.vue?vue&type=script&lang=js&"
export * from "./SoilChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e25a99",
  null
  
)

export default component.exports